import { slick } from './modules/slick.js';
slick();

import { menu } from './modules/menu.js';
menu();

import { position_adjust } from './modules/position_adjust.js';
position_adjust();

import { contact } from './modules/contact.js';
contact();

import { smooth_scroll } from './modules/smooth_scroll.js';
smooth_scroll();

import { ie_objectfit } from './modules/ie_objectfit';
ie_objectfit();

import { ie_picturefill } from './modules/ie_picturefill.js';
ie_picturefill();
